// extracted by mini-css-extract-plugin
export default {"row":"searchSuggestions_row__Dzc7D","label":"searchSuggestions_label__2m9d8","chip":"searchSuggestions_chip__T1bQf","detail":"searchSuggestions_detail__9QrhL"};